
export const environment = {
  production: false,
  AppName: "IposERP",
  baseUrl: "http://192.168.0.36/iposapi",
  NgSelectLimit: 150,
  DisplayName: "iPOSTEK CLT",
  UserUrl: "../../../../assets/plugins/img/stock/user1-128x128.png",
  LogoUrl: "../../../../assets/plugins/img/copilot-logo-white.svg",
  reportUrl: "http://localhost:81/SSRS/",
  noofdecimal: 2,
  DirectBarcodePrint: false,
  MutipleSellingPriceEditable: false,
  RestMutipleSellingPriceEditable: false,
  menuList: [],
  ReportList: [],
  IsRestaurant: true,
  ReportBasedOnPrivilege: true,
  SSRSReportUrl: "http://localhost:81/SSRS/",
  ShowCostPriceOnItemSearch: true,
  ContactMandatoryonBOSale: true,
  SalemanMandatoryonBOSale: true,
  version: "6.0.1.7",
  InclusiveVATOnHTMLReports: false,
  ShowDashBoard: true,
  RecipieDigits: 3,
  EnableMultipleTax: false,
  MultipleIngredientSelection: false,
  DisableFieldsOnUpdate: false,
  ShowItemsBasedOnRoom: true,
  DashBoardOnly: false,
  TaxCaption: "VAT",
  Azure: {
    ClientId: "",
    TenantId: "",
    RedirectBaseUrl: ""
  },
  ShowRestItemLongDescription:false
};




// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/environments/environment.ts